import React from 'react';

import * as S from './styles';

const Gallery02: React.FC = () => {
  return (
    <S.Container>
      <S.Wrapper>
        <S.Photo1
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
          data-wow-delay="200ms"
        />
        <S.Caption className="mobile">
          <p>
            A coleção explora os conjuntos de alfaiataria sob um prisma menos
            conservador, com combinações de bermudas, que parecem fazer
            referência aos looks do final dos anos 1960, década em que
            explodiram marchas por direitos civis pela população LGBTQIA+. |
            Foto: Getty Images
          </p>
        </S.Caption>
        <S.Photo2
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
          data-wow-delay="400ms"
        />
      </S.Wrapper>
      <S.Caption className="mobile">
        <p>
          Cena de protesto em 1969, na Califórnia. Getty Images e reprodução do
          livro “Gay By the Bay – A History of Queer Culture in the San
          Francisco Bay Area”.
        </p>
      </S.Caption>
      <S.Caption className="desktop">
        <p>
          A coleção explora os conjuntos de alfaiataria sob um prisma menos
          conservador, com combinações de bermudas (à esq.), que parecem fazer
          referência aos looks do final dos anos 1960, década em que explodiram
          marchas por direitos civis pela população LGBTQIA+; à dir., cena de
          protesto em 1969, na Califórnia. Getty Images e reprodução do livro
          “Gay By the Bay – A History of Queer Culture in the San Francisco Bay
          Area”.
        </p>
      </S.Caption>
    </S.Container>
  );
};

export default Gallery02;
